import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { faLock, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { EmployeeRole } from 'src/app/enum/employeeRole.enum';
import { IEmployee } from 'src/app/models/employee.model';
import { AuthService } from 'src/app/services/auth.service';
import { HelperService } from 'src/app/services/helper.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HeaderComponent {
  @Input() public userCoinsBalance;

  public employee = {} as IEmployee;

  public passwordDialog = false;

  public logoutIcon = faRightFromBracket;
  public password = faLock;
  public person = faLock;

  public showSidebar = false;
  public isPhoneSize: boolean;
  public EmployeeRole = EmployeeRole;

  constructor(
    private authService: AuthService,
    private helperService: HelperService,
    public router: Router,
  ) {
    this.employee = this.authService.getCurrentEmployee();
  }

  ngOnInit() {
    this.observeSidebarVisibility();
    this.observePhoneSize();
  }

  observeSidebarVisibility(): void {
    this.helperService.showSidebar$.subscribe((visible) => {
      this.showSidebar = visible;
    });
  }

  observePhoneSize(): void {
    this.helperService.isPhoneSize$.subscribe((isPhoneSize) => {
      this.isPhoneSize = isPhoneSize;
    });
  }

  public logout(): void {
    this.authService.logout();
  }
}
